// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-initiative-main-header {
  padding: 12px 40px 12px 16px;
  background-color: var(--grey-light4);
  border: 1px solid var(--grey-light1);
  margin-bottom: 4px;
  position: sticky;
  top: 80px;
  z-index: 1; }
  @media all and (max-width: 991px) {
    .link-initiative-main-header {
      top: 128px; } }

.primary-header {
  background-color: var(--primary-20); }

.title {
  color: var(--primary-100); }

.ant-collapse-item {
  overflow: hidden;
  margin-bottom: 4px;
  border: 1px solid var(--grey-light1); }

.ant-collapse-header {
  background-color: transparent;
  border: 1px solid transparent;
  position: relative;
  padding: 12px 16px;
  padding-right: 40px;
  flex-wrap: nowrap;
  align-items: flex-start;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.5715;
  cursor: pointer;
  transition: all 0.3s, visibility 0s; }
  .ant-collapse-header:hover {
    background-color: var(--secondary-10);
    border: 1px solid var(--secondary-40); }

.empty-list-page {
  height: calc(100vh - 265px);
  display: flex;
  align-items: center;
  justify-content: center; }

.linkProgress .ant-progress-bg {
  background-color: #4f70d1; }

.search-field {
  position: sticky;
  top: 0;
  left: 0;
  background-color: #ffffff;
  z-index: 1; }
  .search-field .sub-header .row {
    margin-right: 12px; }

@media all and (max-width: 500px) {
  .search-field .sub-header {
    flex-direction: column-reverse; }
    .search-field .sub-header .row {
      margin-top: 12px;
      margin-right: 0; } }
`, "",{"version":3,"sources":["webpack://./src/component/linkpage/linkpage.scss"],"names":[],"mappings":"AAAA;EACI,4BAA4B;EAC5B,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU,EAAA;EAEV;IATJ;MAUQ,UAAU,EAAA,EAEjB;;AAED;EACI,mCAAmC,EAAA;;AAGvC;EACI,yBAAyB,EAAA;;AAG7B;EACI,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC,EAAA;;AAGxC;EACI,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,mCAAmC,EAAA;EAXvC;IAcQ,qCAAqC;IACrC,qCAAqC,EAAA;;AAI7C;EACI,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAG3B;EAEQ,yBAAyB,EAAA;;AAIjC;EACI,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,UAAU,EAAA;EALd;IASY,kBAAkB,EAAA;;AAK9B;EACI;IAEQ,8BAA8B,EAAA;IAFtC;MAKY,gBAAgB;MAChB,eAAe,EAAA,EAClB","sourcesContent":[".link-initiative-main-header {\n    padding: 12px 40px 12px 16px;\n    background-color: var(--grey-light4);\n    border: 1px solid var(--grey-light1);\n    margin-bottom: 4px;\n    position: sticky;\n    top: 80px;\n    z-index: 1;\n\n    @media all and (max-width: 991px) {\n        top: 128px;\n    }\n}\n\n.primary-header {\n    background-color: var(--primary-20);\n}\n\n.title {\n    color: var(--primary-100);\n}\n\n.ant-collapse-item {\n    overflow: hidden;\n    margin-bottom: 4px;\n    border: 1px solid var(--grey-light1);\n}\n\n.ant-collapse-header {\n    background-color: transparent;\n    border: 1px solid transparent;\n    position: relative;\n    padding: 12px 16px;\n    padding-right: 40px;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n    color: rgba(0, 0, 0, 0.85);\n    line-height: 1.5715;\n    cursor: pointer;\n    transition: all 0.3s, visibility 0s;\n\n    &:hover {\n        background-color: var(--secondary-10);\n        border: 1px solid var(--secondary-40);\n    }\n}\n\n.empty-list-page {\n    height: calc(100vh - 265px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.linkProgress {\n    .ant-progress-bg {\n        background-color: #4f70d1;\n    }\n}\n\n.search-field {\n    position: sticky;\n    top: 0;\n    left: 0;\n    background-color: #ffffff;\n    z-index: 1;\n\n    .sub-header {\n        .row {\n            margin-right: 12px;\n        }\n    }\n}\n\n@media all and (max-width: 500px) {\n    .search-field {\n        .sub-header {\n            flex-direction: column-reverse;\n\n            .row {\n                margin-top: 12px;\n                margin-right: 0;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
